<!--
	Fragment skeleton for ConnectedRepositoryCard. Rendered inside a parent
	`.resource-card` container so it reuses the real card's section rhythm (the
	global .resource-card / .resource-card__* layout). Spacing/structure changes
	to the card propagate here automatically — only the SkeletonBlock widths are
	card-specific.

	Two contexts:
	- Inside ConnectedRepositoryCard while repoDetailsFromRepoHost loads
	  (withHeader=false — the real card renders the icon + placeholder name above).
	- Inside Repositories.vue before connectedRepositories resolves
	  (withHeader=true — no real card, so the skeleton draws its own header).
-->
<template>
	<div
		v-if="withHeader"
		class="resource-card__title-name sgnl-flex sgnl-align-center"
	>
		<SkeletonBlock
			width="var(--sgnl-icon-24)"
			height="var(--sgnl-icon-24)"
		/>
		<SkeletonBlock
			width="70%"
			class="sgnl-paragraph-m-medium"
		/>
	</div>
	<div class="resource-card__description sgnl-paragraph-s-regular">
		<SkeletonBlock width="90%" />
	</div>
	<!--
		Pixel widths intentionally mirror the rendered widths of the real card's
		chip badges, footer line, and action buttons. Do not tokenize — drift
		introduces a layout shift when repoDetailsFromRepoHost arrives.
	-->
	<div class="resource-card__config sgnl-flex sgnl-flex-wrap sgnl-align-center sgnl-gap-8">
		<SkeletonBlock
			width="95px"
			height="var(--sgnl-unit-24)"
			radius="var(--sgnl-border-radius-6)"
		/>
		<SkeletonBlock
			width="110px"
			height="var(--sgnl-unit-24)"
			radius="var(--sgnl-border-radius-6)"
		/>
		<SkeletonBlock
			width="85px"
			height="var(--sgnl-unit-24)"
			radius="var(--sgnl-border-radius-6)"
		/>
		<SkeletonBlock
			width="var(--sgnl-unit-64)"
			height="var(--sgnl-unit-24)"
			radius="var(--sgnl-border-radius-6)"
		/>
		<SkeletonBlock
			width="var(--sgnl-unit-64)"
			height="var(--sgnl-unit-24)"
			radius="var(--sgnl-border-radius-6)"
		/>
	</div>
	<div class="resource-card__footer">
		<div class="sgnl-flex sgnl-align-center sgnl-flex-wrap sgnl-gap-8">
			<SkeletonBlock
				width="300px"
				height="var(--sgnl-unit-24)"
				radius="var(--sgnl-border-radius-6)"
			/>
			<SkeletonBlock
				width="332px"
				height="var(--sgnl-unit-24)"
				radius="var(--sgnl-border-radius-6)"
			/>
		</div>
		<div class="sgnl-flex sgnl-align-center sgnl-gap-8">
			<SkeletonBlock
				width="90px"
				btn
			/>
			<SkeletonBlock
				width="var(--sgnl-unit-64)"
				btn
			/>
			<SkeletonBlock
				width="var(--sgnl-unit-64)"
				btn
			/>
			<SkeletonBlock
				width="var(--sgnl-unit-64)"
				btn
			/>
			<v-spacer />
			<SkeletonBlock
				width="var(--sgnl-unit-64)"
				btn
			/>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import SkeletonBlock from "@/components/Common/SkeletonBlock.vue";

export default defineComponent({
	name: "ConnectedRepositoryCardSkeleton",
	components: { SkeletonBlock },
	props: {
		withHeader: { type: Boolean, default: false },
	},
});
</script>
